<template>
  <v-container id="clientes" tag="section">
    <base-v-component heading="Facturas del sistema " />
    <base-material-card
      color="indigo"
      icon="mdi-currency-eur"
      inline
      class="px-5 py-3"
    >
      <v-row justify="center" align="center">
        <v-col cols="12" md="2">
          <v-text-field
            :loading="loadingNumeroSiguiente"
            label="Número de factura siguiente"
            v-model="numeroSiguiente"
            :disabled="!numeroFacturaCambiando"
          />
        </v-col>
        <v-col cols="4"></v-col>
        <v-col cols="12" md="4">
          <v-btn
            v-if="!numeroFacturaCambiando"
            :loading="loadingNumeroSiguiente"
            @click="numeroFacturaCambiando = true"
            >Cambiar</v-btn
          >
          <v-btn
            v-else
            :loading="loadingNumeroSiguiente"
            @click="cambiarNumeroFactura"
            >Aceptar cambio</v-btn
          >
        </v-col>
        <v-col cols="12" md="4">
          <v-btn color="info" @click="openListadoFacturas"
            >Listado Facturas</v-btn
          >
        </v-col>
      </v-row>
      <v-dialog v-model="listadoFacturasDialog" max-width="800">
        <v-card>
          <v-card-title> LISTADO FACTURAS </v-card-title>
          <v-card-text>
            <h4>Elige fechas</h4>
            <v-row justify="center">
              <v-col cols="12" md="6">
                <v-date-picker
                  class="mx-auto"
                  first-day-of-week="1"
                  v-model="fechas"
                  range
                  locale="es"
                ></v-date-picker>
              </v-col>
              <v-col cols="12" md="6">
                <v-card-text>{{ fechas.join(" - ") }}</v-card-text>
                <v-autocomplete
                  :items="$store.state.app.negociosGestArray"
                  v-model="listadoFacturaNegocios"
                  multiple
                  label="Negocios"
                />
                <v-btn @click="descargarListado"> Descargar </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-toolbar flat color="white">
        <v-row no-gutters align="center">
          <v-btn
            color="success"
            dark
            class="mb-2"
            @click="goAdd()"
            :loading="loadingNumeroSiguiente"
            >Crear Factura</v-btn
          >
          <v-text-field
            class="mx-4"
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer />
          <v-btn-toggle v-model="estadoFiltrando" mandatory>
            <v-btn value="generada" class="black--text"> Generada </v-btn>
            <v-btn value="archivada" class="black--text"> Archivada </v-btn>
            <v-btn value="marcadas" class="black--text"> Marcadas </v-btn>
            <v-btn value="todas" class="black--text"> Todas </v-btn>
          </v-btn-toggle>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="reload()">
            <v-icon color="white">mdi-autorenew</v-icon>
          </v-btn>
        </v-row>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="facturas"
        :loading="loading"
        :search="search"
        sort-by="fecha"
        sort-desc
      >
        <template v-slot:item.estadoMostrar="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip small class="mr-2 pa-1 info" v-on="on"
                ><v-icon color="white">mdi-information</v-icon></v-chip
              >
            </template>
            <span>{{ item.estado }}</span>
          </v-tooltip>
          <v-tooltip top v-if="item.resumen.totalTransferir > 0">
            <template v-slot:activator="{ on }">
              <v-chip
                small
                class="mr-2 pa-1"
                :class="item.transferido ? 'success' : 'red'"
                v-on="on"
                ><v-icon color="white">mdi-credit-card</v-icon></v-chip
              >
            </template>
            <span v-if="!item.transferido">No transferido</span>
            <span v-else>Transferido: {{ item.transferido }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip
                small
                class="mr-2 pa-1"
                :class="item.cobrado ? 'success' : 'red'"
                v-on="on"
                ><v-icon color="white">mdi-currency-eur</v-icon></v-chip
              >
            </template>
            <span v-if="!item.cobrado">No cobrado</span>
            <span v-else>Cobrado: {{ item.cobrado }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip
                small
                class="mr-2 pa-1"
                :class="item.enviado ? 'success' : 'red'"
                v-on="on"
                ><v-icon color="white">mdi-email</v-icon></v-chip
              >
            </template>
            <span v-if="!item.enviado">No enviado</span>
            <span v-else>Enviado: {{ item.enviado }}</span>
          </v-tooltip>
          <v-tooltip top v-if="!!item.comisionBtn">
            <template v-slot:activator="{ on }">
              <v-chip small class="mr-2 pa-1 info" v-on="on"
                ><v-icon color="white">mdi-content-paste</v-icon></v-chip
              >
            </template>
            <span
              >Comisión generada el {{ item.comisionBtn.fechaMostrar }}</span
            >
          </v-tooltip>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-spacer></v-spacer>
          <v-tooltip top v-if="!item.holdedId">
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="purple"
                min-width="0"
                :loading="loading"
                v-on="on"
                small
                @click="volcarHolded(item)"
              >
                <v-icon small>mdi-reload</v-icon>
              </v-btn>
            </template>
            <span>Volcar en Holded</span>
          </v-tooltip>
          <v-tooltip top v-else>
            <template v-slot:activator="{ on }">
              <v-btn
                disabled
                class="px-2 ml-1"
                color="grey"
                min-width="0"
                :loading="loading"
                v-on="on"
                small
              >
                <v-icon small>mdi-reload</v-icon>
              </v-btn>
            </template>
            <span>Volcado en holded</span>
          </v-tooltip>
          <v-tooltip top v-if="item.estado != 'archivada'">
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="secondary"
                min-width="0"
                :loading="item.loadingArchivar"
                v-on="on"
                small
                @click="archivar(item)"
              >
                <v-icon small>mdi-archive-arrow-down</v-icon>
              </v-btn>
            </template>
            <span>Archivar</span>
          </v-tooltip>
          <v-tooltip top v-if="item.comision">
            <!-- v-if="
              item.estado != 'archivada' && item.comision && !item.comisionBtn
            " -->
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="orange"
                min-width="0"
                :loading="item.loadingComision"
                v-on="on"
                small
                @click="abrirDialogGenerarComision(item)"
              >
                <v-icon small>mdi-content-paste</v-icon>
              </v-btn>
            </template>
            <span>Generar comisión {{ item.comision }}</span>
          </v-tooltip>
          <!-- <v-tooltip top v-else-if="!!item.comisionBtn">
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="success"
                min-width="0"
                :loading="item.loadingArchivar"
                v-on="on"
                small
              >
                <v-icon small>mdi-content-paste</v-icon>
              </v-btn>
            </template>
            <span
              >Comisión generada el {{ item.comisionBtn.fechaMostrar }}</span
            >
          </v-tooltip> -->
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="success"
                min-width="0"
                v-on="on"
                small
                @click="view(item)"
              >
                <v-icon small>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Ver más</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                @click="eliminarFactura(item)"
                class="px-2 ml-1"
                color="red"
                min-width="0"
                small
                v-on="on"
                :loading="loadingEliminar"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Eliminar factura</span>
          </v-tooltip>
        </template>
      </v-data-table></base-material-card
    >
    <v-dialog v-model="generarComisionDialog" max-width="500">
      <v-card>
        <v-card-title>Generar comisión</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                type="number"
                step="0.05"
                v-model="datosComision.comisionPorcentaje"
                label="Comisión"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn
                @click="generarComision"
                color="primary"
                :loading="generarComisionLoading"
                >Generar comisión</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import { mostrarMoneda, idToTexto, mostrarIdioma } from "@/utils/utils.js";
export default {
  data() {
    return {
      fechas: [],
      listadoFacturaNegocios: [],
      listadoFacturasDialog: false,
      numeroFacturaCambiando: false,
      loadingNumeroSiguiente: false,
      numeroSiguiente: null,
      loading: false,
      loadingEliminar: false,
      dialog: false,
      generarComisionDialog: false,
      generarComisionLoading: false,
      datosComision: {}, //objeto que tiene la factura y el porcentaje ajustado de comisión
      headers: [
        {
          sortable: false,
          text: "#",
          value: "id",
        },
        {
          sortable: false,
          text: "Modo",
          value: "modo",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "nombre",
        },
        {
          sortable: false,
          text: "Estado",
          value: "estadoMostrar",
        },
        {
          sortable: false,
          text: "Periodo",
          value: "periodo",
        },
        {
          sortable: false,
          text: "Total",
          value: "total",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    search: {
      get() {
        return this.$store.state.facturacion.search;
      },
      set(v) {
        this.$store.commit("facturacion/setSearch", v);
      },
    },
    estadoFiltrando: {
      get() {
        return this.$store.state.facturacion.estadoFiltrando;
      },
      set(v) {
        this.$store.commit("facturacion/setEstadoFiltrando", v);
        this.reload();
      },
    },
    facturas() {
      var facturas = this.$store.state.facturacion.facturasArray;
      var res = [];
      facturas.forEach((f) => {
        var foundTransferido, index;
        index = f.historial ? f.historial.length - 1 : -1;
        for (; index >= 0; index--) {
          if (f.historial[index].transferidoNegocio != undefined) {
            foundTransferido = f.historial[index];
            break;
          }
        }
        let transferido;
        if (foundTransferido) {
          transferido = moment(
            foundTransferido.transferidoNegocio.toDate()
          ).format("DD-MM-YYYY HH:mm");
        } else {
          transferido = false;
        }
        var foundCobrado, index;
        index = f.historial ? f.historial.length - 1 : -1;
        for (; index >= 0; index--) {
          if (f.historial[index].transferidoMewo != undefined) {
            foundCobrado = f.historial[index];
            break;
          }
        }
        let cobrado;
        if (foundCobrado) {
          cobrado = moment(foundCobrado.transferidoMewo.toDate()).format(
            "DD-MM-YYYY HH:mm"
          );
        } else {
          cobrado = false;
        }
        var foundEnviado, index;
        index = f.historial ? f.historial.length - 1 : -1;
        for (; index >= 0; index--) {
          if (f.historial[index].envioEmail != undefined) {
            foundEnviado = f.historial[index];
            break;
          }
        }
        let enviado;
        if (foundEnviado) {
          enviado = moment(foundEnviado.envioEmail.toDate()).format(
            "DD-MM-YYYY HH:mm"
          );
        } else {
          enviado = false;
        }
        var foundComision, index;
        index = f.historial ? f.historial.length - 1 : -1;
        for (; index >= 0; index--) {
          if (f.historial[index].comisionGenerada != undefined) {
            foundComision = f.historial[index];
            break;
          }
        }
        var comisionBtn;
        if (foundComision) {
          comisionBtn = foundComision;
          comisionBtn.fechaMostrar = moment(
            foundComision.comisionGenerada.toDate()
          ).format("DD-MM-YYYY HH:mm");
        } else {
          comisionBtn = false;
        }

        var comision = false;
        //mirar si es comisionable
        if (f.estado == "generada" || f.estado == "archivada") {
          var foundPartner = this.$store.state.partners.partners.find((p) =>
            p.negocios.includes(f.negocio)
          );
          comision = foundPartner ? foundPartner.id : null;
        }

        res.push({
          ...f,
          id: f.id,
          modo: f.modo ? idToTexto(f.modo) : "-",
          nombre:
            f.modo == "negocio" || f.modo == "directorio"
              ? idToTexto(f.negocio)
              : idToTexto(f.restaurante[0]),
          periodo: f.rango ? f.rango.join(" / ") : "-",
          total: f.resumen ? f.resumen.totalCantidadFacturar : "",
          estadoMostrar: idToTexto(f.estado),
          transferido: transferido,
          cobrado: cobrado,
          enviado: enviado,
          comision: comision,
          comisionBtn: comisionBtn,
        });
      });
      return res;
    },
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
    }),
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    subtitulo() {
      return "Listado de facturas de todo el sistema";
    },
  },
  watch: {
    listadoFacturasDialog(v) {
      if (!v) {
        this.fechas = [];
      }
    },
  },
  methods: {
    volcarHolded(item) {
      var _vm = this;
      this.$confirm("¿Desea volcar la factura en Holded? ", {
        buttonTrueText: "Aceptar",
        buttonFalseText: "No",
        color: "warning",
        icon: "warning",
        width: 350,
      })
        .then((r) => {
          if (r) {
            this.loading = true;
            confirm = true;
            return this.$store.dispatch("facturacion/volcarHolded", item);
          }
        })
        .then(() => {
          if (confirm) {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Factura volcada",
            });
            _vm.reload();
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido archivar la factura " + e,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    descargarListadoHolded() {
      this.$store.dispatch("facturacion/descargarListadoFacturasHolded", {
        fechas: this.fechas,
        negocios: this.listadoFacturaNegocios,
      });
    },
    descargarListado() {
      this.$store.dispatch("facturacion/descargarListadoFacturas", {
        fechas: this.fechas,
        negocios: this.listadoFacturaNegocios,
      });
    },
    openListadoFacturas() {
      this.listadoFacturasDialog = true;
    },
    archivar(item) {
      var _vm = this;
      this.$confirm("¿Desea archivar la factura? ", {
        buttonTrueText: "Aceptar",
        buttonFalseText: "No",
        color: "warning",
        icon: "warning",
        width: 350,
      })
        .then((r) => {
          if (r) {
            item.loadingArchivar = true;
            confirm = true;
            return this.$store.dispatch("facturacion/archivarFactura", item);
          }
        })
        .then(() => {
          if (confirm) {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Factura archivada",
            });
            _vm.reload();
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido archivar la factura " + e,
          });
        })
        .finally(() => {
          item.loadingArchivar = false;
        });
    },
    view(item) {
      this.$router.push("/admin/facturacion/form/" + item.id);
    },
    eliminarFactura(item) {
      let _vm = this;
      var confirm = false;
      this.$confirm(
        "¿Desea eliminar la factura? Esta acción es irreversible?",
        {
          buttonTrueText: "Aceptar",
          buttonFalseText: "No",
          color: "warning",
          icon: "warning",
          width: 350,
        }
      )
        .then((r) => {
          if (r) {
            confirm = true;
            _vm.loadingEliminar = true;
            return this.$store.dispatch("facturacion/eliminarFactura", item.id);
          }
        })
        .then(() => {
          if (confirm) {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Factura eliminada",
            });
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido eliminar la factura " + e,
          });
        })
        .finally(() => {
          _vm.loadingEliminar = false;
          _vm.reload();
        });
    },
    goAdd() {
      this.$router.push("/admin/facturacion/form");
    },
    reload() {
      let _vm = this;
      _vm.loading = true;
      this.$store
        .dispatch("facturacion/getFacturas")
        .then(() => {})
        .catch((e) => {
          console.log(e);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se han podido cargar las facturas " + e,
          });
        })
        .finally(() => (_vm.loading = false));
    },
    async abrirDialogGenerarComision(item) {
      console.log(item);
      this.datosComision = item;
      let res = await this.$store.dispatch(
        "facturacion/datosPartnerComision",
        item
      );
      if (!!res) {
        this.datosComision.comisionPorcentaje = res.comisionPorcentaje;
      }
      console.log(this.datosComision);
      this.generarComisionDialog = true;
    },
    generarComision() {
      const _vm = this;
      this.generarComisionLoading = true;
      this.$store
        .dispatch("facturacion/generarComision", this.datosComision)
        .then(() => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Comisión generada ",
          });
          this.generarComisionDialog = false;
        })
        .catch((e) => {
          console.log(e);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se han podido generar la comisión " + e,
          });
        })
        .finally(() => {
          this.generarComisionLoading = false;
          _vm.reload();
        });
    },

    getNumeroFacturaSiguiente() {
      this.loadingNumeroSiguiente = true;
      return this.$store
        .dispatch("facturacion/getNumeroFacturaSiguiente")
        .then((r) => {
          this.numeroSiguiente = r;
        })
        .finally(() => {
          this.loadingNumeroSiguiente = false;
          this.numeroFacturaCambiando = false;
        });
    },
    cambiarNumeroFactura() {
      this.loadingNumeroSiguiente = true;
      this.$store
        .dispatch(
          "facturacion/setNumeroFacturaSiguiente",
          parseInt(this.numeroSiguiente)
        )
        .then((r) => {
          // return this.getNumeroFacturaSiguiente();
        })
        .finally(() => {
          this.loadingNumeroSiguiente = false;
          this.numeroFacturaCambiando = false;
        });
    },
  },
  mounted() {
    this.getNumeroFacturaSiguiente();
    if (this.facturas.length == 0) this.reload();
    return Promise.all([
      this.reload(),
      this.$store.dispatch("partners/getPartners"),
    ]);
  },
};
</script>

<style>
</style>